import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import { selectProgressGlobalPending } from '../../../../redux/appointmentForm/selectors';
import styles from './styles.styl';

const mapStateToProps = state => ({
  globalPending: selectProgressGlobalPending(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/AppointmentHeader/enhance.js